// traj.js
// import * as BABYLON from 'babylonjs';

var BABYLON = null;
var MATERIALS = null;
var GUI = null;

var CANVAS = null;

// Existing code
var label;
var noTrajLabel;
var myPoints = [];
var trajMat = null;
var trajMatCalc = null;
var camera = null;
var scene = null;
var shadowGenerator = null;
var advancedTexture = null;
const lineOptions = {
    points: myPoints,
    updatable: true
}
let trajLine;
let trajLineCalc;
let guideLines = [];
let guideLabels = [];
let guideLabelsM = [];
var maxShotDistance = 0;
var maxShotApex = 0;
var maxDispersion = 0;
var GuideLineMaterial;
var engine;

//X 1   disp
//Y 2   up
//Z 0   forward
let tickEveryX = 30;//ft
let tickEveryY = 30;//ft
let tickEveryZ = 90;//ft

let previousCameraState = {};
let saveCameraTimeout;

function initializeScene(_BABYLON, _MAT, _GUI, _CANVAS) {
    BABYLON = _BABYLON;
    MATERIALS = _MAT;
    GUI = _GUI;
    drawScene(_CANVAS);
    
}

function resetScene(){
    if(engine){
        engine.dispose();
        engine = null;
    }
}

function saveCameraStateToLocalStorage(camera) {
    if (camera) {
        const cameraState = {
            alpha: camera.alpha,
            beta: camera.beta,
            radius: camera.radius,
        };
        localStorage.setItem("threeDCameraState", JSON.stringify(cameraState));
    }
}

function loadedCameraValues(){
    const cameraStateString = localStorage.getItem("threeDCameraState");
    if (cameraStateString) {
        return JSON.parse(cameraStateString);
    }
    return {alpha:DegToRad(-15), beta:DegToRad(35), radius:120};
}

function hasCameraChanged(camera) {
    const currentState = {
        alpha: camera.alpha,
        beta: camera.beta,
        radius: camera.radius,
    };

    const isChanged =
        !previousCameraState ||
        currentState.alpha !== previousCameraState.alpha ||
        currentState.beta !== previousCameraState.beta ||
        currentState.radius !== previousCameraState.radius;

    previousCameraState = { ...currentState }; // Update previous state
    return isChanged;
}

function drawScene(_CANVAS){
    var canvas = _CANVAS;
    CANVAS = _CANVAS;

    resetScene();
    engine = new BABYLON.Engine(canvas, true);

    var createScene = function(){
        scene = new BABYLON.Scene(engine);
        scene.clearColor = BABYLON.Color3.FromHexString('#87CEEB');
        advancedTexture = GUI.AdvancedDynamicTexture.CreateFullscreenUI("UI");
        const camValues = loadedCameraValues();
        camera = new BABYLON.ArcRotateCamera("camera1", camValues.alpha, camValues.beta, camValues.radius, BABYLON.Vector3.Zero(), scene);

        camera.minZ = 0.01;
        camera.maxZ = 1200;
        camera.lowerRadiusLimit = 2;
        camera.upperRadiusLimit = 200;

        camera.setTarget(BABYLON.Vector3.Zero());
        camera.attachControl(canvas, true);

        camera.onAfterCheckInputsObservable.add(() => {
            if (hasCameraChanged(camera)) {
                clearTimeout(saveCameraTimeout);
                saveCameraTimeout = setTimeout(() => {
                    saveCameraStateToLocalStorage(camera);
                }, 50); // Save 50ms after last detected change
            }
        });

        var light = new BABYLON.DirectionalLight("light1", new BABYLON.Vector3(0, -1, 0), scene);
        light.intensity = 0.9;
        shadowGenerator = new BABYLON.CascadedShadowGenerator(2048, light);
        shadowGenerator.numCascades = 6;
        shadowGenerator.cascadeBlendPercentage = 0.05;

        var ground = BABYLON.MeshBuilder.CreateGround("ground", { width: 1000, height: 1000 }, scene);
        ground.layerMask = camera.layerMask;
        ground.receiveShadows = true;

        var groundMat = new BABYLON.StandardMaterial("groundMaterial", scene);
        groundMat.diffuseColor = new BABYLON.Color3(131/255, 139/255, 103/255);
        groundMat.specularColor = new BABYLON.Color3(0, 0, 0);
        ground.material = groundMat;
        ground.position = new BABYLON.Vector3(0, -0.15, 0);

        const skyMaterial = new MATERIALS.SkyMaterial("skyMaterial", scene);
        skyMaterial.backFaceCulling = false;
        skyMaterial.disableLighting = true;
        skyMaterial.infiniteDistance = true;
        skyMaterial.inclination = 0;
        skyMaterial.luminance = 0.8;
        skyMaterial.cameraOffset.y = 50;

        const skybox = BABYLON.MeshBuilder.CreateBox("skybox", { size: 1200.0 }, scene);
        skybox.material = skyMaterial;
        


        trajMat = new BABYLON.StandardMaterial("trajMat", scene);
        trajMat.diffuseColor = new BABYLON.Color3(1, 1, 0);
        trajMat.emissiveColor = new BABYLON.Color3(1, 1, 0);
        trajMat.backFaceCulling = false;
        trajMat.shadowCaster = true;

        trajMatCalc = new BABYLON.StandardMaterial("trajMatCalc", scene);
        trajMatCalc.diffuseColor = new BABYLON.Color3(0, 0, 1);
        trajMatCalc.emissiveColor = new BABYLON.Color3(0, 0, 1);
        trajMatCalc.alpha = 0.1;
        trajMatCalc.backFaceCulling = false;
        trajMatCalc.shadowCaster = true;

        var ray = new BABYLON.Ray();
        scene.onPointerObservable.add((pointerInfo) => {
            var pickResult = scene.pick(pointerInfo.event.clientX, pointerInfo.event.clientY, function (mesh) { return mesh === trajLine; });
            if (pickResult.hit) {
                ray.origin = pickResult.pickedPoint;
                ray.direction = pickResult.getNormal(true);
                var point = pickResult.pickedPoint;
                drawPointText(point);
            } else { drawPointText(null); }
        });

        label = new GUI.TextBlock();
        label.text = "";
        label.color = "white";
        label.fontSize = 24;
        label.textHorizontalAlignment = GUI.Control.HORIZONTAL_ALIGNMENT_LEFT;
        label.textVerticalAlignment = GUI.Control.VERTICAL_ALIGNMENT_BOTTOM;
        label.paddingLeftInPixels = 15;
        label.paddingBottomInPixels = 15;
        advancedTexture.addControl(label);

        noTrajLabel = new GUI.TextBlock();
        noTrajLabel.color = "white";
        noTrajLabel.text = "No Trajectory Selected";
        noTrajLabel.fontSize = 24;
        advancedTexture.addControl(noTrajLabel);

        return scene;
    }

    var scene = createScene();
    engine.runRenderLoop(function(){
        scene.render();
    });

    GuideLineMaterial = new BABYLON.StandardMaterial("guideLineMat", scene);
    GuideLineMaterial.diffuseColor = new BABYLON.Color3(1, 1, 1);
    GuideLineMaterial.emissiveColor = new BABYLON.Color3(1, 1, 1);
    GuideLineMaterial.alpha = 0.5;
}

function drawTraj(data) {
    if (trajLine != null)
        trajLine.dispose();

    var trajData;
    myPoints = [];
    if(data != null && data != "") {
        trajData = data;
        if(noTrajLabel)
            noTrajLabel.text = "";
    } else {
        if(noTrajLabel)
            noTrajLabel.text = "No Trajectory Selected";
        ClearLines();
        return;
    }

    var midTraj = new BABYLON.Vector3(
        (trajData[0][1] + trajData[trajData.length - 1][1]) / 2,
        0,
        (trajData[0][0] + trajData[trajData.length - 1][0]) / 2);

    for(var i = 0; i < trajData.length; ++i) {
        myPoints.push(new BABYLON.Vector3(
            trajData[i][1],
            trajData[i][2],
            trajData[i][0]) );
    }

    trajLine = BABYLON.MeshBuilder.CreateTube("traj", { path: myPoints, radius: 0.45, sideOrientation: BABYLON.Mesh.DOUBLESIDE, cap: BABYLON.Mesh.CAP_ALL, updatable: true }, scene);
    trajLine.material = trajMat;
    shadowGenerator.getShadowMap().renderList.push(trajLine);
    

    maxShotDistance = trajData[trajData.length - 1][0];
    maxShotApex = Math.max(...trajData.map(item => item[2]));
    let maxDisp = Math.max(...trajData.map(item => item[1]));
    let minDisp = Math.min(...trajData.map(item => item[1]));
    maxDispersion = (maxDisp > Math.abs(minDisp) ? maxDisp : Math.abs(minDisp));

    const camValues = loadedCameraValues();

    camera.setTarget(midTraj);
    camera.setPosition(new BABYLON.Vector3(midTraj.x + clamp(maxShotDistance * 0.7,-125,125), 40, midTraj.z));
    camera.alpha = camValues.alpha;
    camera.beta = camValues.beta;
    camera.radius = camValues.radius;

    DrawGuide();
}

function drawTrajCalc(data) {

    if(BABYLON === undefined || BABYLON === null)
        return;

    if (trajLineCalc != null)
        trajLineCalc.dispose();

    const isMainTraj = trajLine === null;

    var trajData;
    myPoints = [];
    if(data != null && data != "") {
        trajData = data;
        if(isMainTraj)
            noTrajLabel.text = "";
    } else {
        if(isMainTraj){
            noTrajLabel.text = "No Trajectory Selected";
            ClearLines();
        }
        return;
    }

    for(var i = 0; i < trajData.length; ++i) {
        myPoints.push(new BABYLON.Vector3(
            trajData[i][1],
            trajData[i][2],
            trajData[i][0]) );
    }

    if(isMainTraj){
        maxShotDistance = trajData[trajData.length - 1][0];
        maxShotApex = Math.max(...trajData.map(item => item[2]));
        let maxDisp = Math.max(...trajData.map(item => item[1]));
        let minDisp = Math.min(...trajData.map(item => item[1]));
        maxDispersion = (maxDisp > Math.abs(minDisp) ? maxDisp : Math.abs(minDisp));


        var midTraj = new BABYLON.Vector3(
            (trajData[0][1] + trajData[trajData.length - 1][1]) / 2,
            0,
            (trajData[0][0] + trajData[trajData.length - 1][0]) / 2);

        // camera.setTarget(midTraj);
        // camera.setPosition(new BABYLON.Vector3(midTraj.x + clamp(maxShotDistance * 0.7,-125,125), 40, midTraj.z));
    }

    const radiusSize = !isMainTraj ? 0.25 : 0.45;

    trajLineCalc = BABYLON.MeshBuilder.CreateTube("traj", { path: myPoints, radius: radiusSize, sideOrientation: BABYLON.Mesh.DOUBLESIDE, cap: BABYLON.Mesh.CAP_ALL, updatable: true }, scene);
    trajLineCalc.material = !isMainTraj ? trajMatCalc : trajMat;
    shadowGenerator.getShadowMap().renderList.push(trajLineCalc);
}

function DrawGuide() {
    ClearLines();
    DrawGuide_MainLine("z");
    DrawGuide_MainLine("y");
    DrawGuide_DrawTicks("z");
    DrawGuide_DrawTicks("y");
    DrawGuide_DrawTicks("x");
    const parentElement = CANVAS?.parentElement;
    try{
        if (parentElement && parentElement.id && parentElement.id === "megaTraj") {
            DrawGuide_DrawLabels("x");
            DrawGuide_DrawLabels("y");
            DrawGuide_DrawLabels("z");
        }
    }catch(e){
        console.log(e.stack);
    }
    
}

function ClearLines() {
    for (var l = 0; l < guideLines.length; ++l) {
        guideLines[l].dispose();
    }
    guideLines = [];

    for (var a = 0; a < guideLabels.length; ++a) {
        guideLabels[a].dispose();
    }
    guideLines = [];

    for (var m = 0; m < guideLabelsM.length; ++m) {
        guideLabelsM[m].dispose();
    }
    guideLabelsM = [];
}

function DrawGuide_MainLine(axis) {
    switch (axis) {
        case "z":
            let zPoints = [
                new BABYLON.Vector3(0, 0, 0),
                new BABYLON.Vector3(0, 0, GetAdjustedMeasurement(maxShotDistance,"z"))]
            let zline = BABYLON.MeshBuilder.CreateLines("zline", { points: zPoints });
            zline.material = GuideLineMaterial;
            guideLines.push(zline);
            break;
        case "y":
            let yPoints = [
                new BABYLON.Vector3(0, 0, GetAdjustedMeasurement(maxShotDistance, "z")),
                new BABYLON.Vector3(0, GetAdjustedMeasurement(maxShotApex, "y"), GetAdjustedMeasurement(maxShotDistance, "z"))]
            let yline = BABYLON.MeshBuilder.CreateLines("yline", { points: yPoints });
            yline.material = GuideLineMaterial;
            guideLines.push(yline);
            break;
    }
}

function DrawGuide_DrawTicks(axis) {
    switch (axis) {
        case "x":
            let xTicks = GetAdjustedMeasurement(maxShotApex, "y") / FtToM(tickEveryY);
            for (var x = 1; x < xTicks + 1; ++x) {
                let xDist = FtToM(tickEveryY) * x;
                let xMaxDist = GetAdjustedMeasurement(maxShotDistance, "z");
                let xPoints = [
                    new BABYLON.Vector3(0, xDist, 0),
                    new BABYLON.Vector3(0, xDist, xMaxDist)
                ];
                let xline = BABYLON.MeshBuilder.CreateLines("xlinet", { points: xPoints });
                xline.material = GuideLineMaterial;
                guideLines.push(xline);
            }
            break;
        case "y":
            let yTicks = GetAdjustedMeasurement(maxShotDistance, "z") / FtToM(tickEveryZ);
            for (var y = 0; y < yTicks; ++y) {
                let yDist = FtToM(tickEveryZ) * y;
                let yMaxDist = GetAdjustedMeasurement(maxShotApex, "y");
                let yPoints = [
                    new BABYLON.Vector3(0, 0, yDist),
                    new BABYLON.Vector3(0, yMaxDist, yDist)
                ];
                let yline = BABYLON.MeshBuilder.CreateLines("ylinet", { points: yPoints });
                yline.material = GuideLineMaterial;
                guideLines.push(yline);
            }
            break;
        case "z":
            let zTicks = GetAdjustedMeasurement(maxShotDistance, "z") / FtToM(tickEveryZ);
            for (var z = 0; z < zTicks + 1; ++z) {
                let zDist = FtToM(tickEveryZ) * z;
                let xMaxDist = GetAdjustedMeasurement(maxDispersion, "x");
                xMaxDist = xMaxDist * (z / zTicks);
                let zPoints = [
                    new BABYLON.Vector3(xMaxDist, 0, zDist),
                    new BABYLON.Vector3(-xMaxDist, 0, zDist)
                ];
                let zline = BABYLON.MeshBuilder.CreateLines("zlinet", { points: zPoints });
                zline.material = GuideLineMaterial;
                guideLines.push(zline);
            }
            break;
    }
}

function DrawGuide_DrawLabels(axis) {
    switch (axis) {
        case "x":
            
            let xPos = GetAdjustedMeasurement(maxDispersion, "x");
            let zPos = GetAdjustedMeasurement(maxShotDistance, "z");
            let xPoint1 = new BABYLON.Vector3(xPos, 0, zPos);
            let xPoint2 = new BABYLON.Vector3(-xPos, 0, zPos);

            let xLabel1 = CreateLabel(xPoint1, Math.trunc(MToFt(xPos)/3).toString(), axis);
            let xLabel2 = CreateLabel(xPoint2, Math.trunc(MToFt(xPos)/3).toString(), axis);
            guideLabelsM.push(xLabel1);
            guideLabelsM.push(xLabel2);
            break;
        case "y":
            let xTicks = GetAdjustedMeasurement(maxShotApex, "y") / FtToM(tickEveryY);
            for (var x = 1; x < xTicks + 1; ++x) {
                let xDist = FtToM(tickEveryY) * x;
                let xPoint = new BABYLON.Vector3(0, xDist, 0);
                let yLabel = CreateLabel(xPoint, ((x * tickEveryY)/3).toString(), axis);
                guideLabelsM.push(yLabel);
            }
            break;
        case "z":
            let yTicks = GetAdjustedMeasurement(maxShotDistance, "z") / FtToM(tickEveryZ);
            for (var y = 1; y < yTicks + 1; ++y) {
                let yDist = FtToM(tickEveryZ) * y;
                let yMaxDist = GetAdjustedMeasurement(maxShotApex, "y");
                let yPoint = new BABYLON.Vector3(0, 0, yDist);
                let zLabel = CreateLabel(yPoint, ((y * tickEveryZ) / 3).toString(), axis);
                guideLabelsM.push(zLabel);
            }
            break;
    }
}

function CreateLabel(position, text, axis) {
    let labelWidth = 8;
    let labelHeight = 8;
    var labelMesh = new BABYLON.Mesh("labelM", scene);
    switch (axis) {
        case "x":
            labelMesh.position = new BABYLON.Vector3(position.x, position.y - (labelHeight / 2), position.z);
            break;
        case "y":
            labelMesh.position = new BABYLON.Vector3(position.x, position.y, position.z - (labelWidth / 2));
            break;
        case "z":
            labelMesh.position = new BABYLON.Vector3(position.x, position.y - (labelHeight / 2), position.z);
            break;
    }
    var label = new GUI.TextBlock();
    label.text = text;
    label.color = "rgba(1,1,1,0.3)";
    label.fontSize = 20;

    advancedTexture.addControl(label);
    label.linkWithMesh(labelMesh);
    guideLabels.push(label);

    return labelMesh;
}

function GetAdjustedMeasurement(value, axis) {
    let returnValue = 0;
    switch (axis) {
        case "x":
            let xFt = MToFt(value);
            let xDiff = Math.ceil(xFt / tickEveryX);
            returnValue = FtToM(xDiff * tickEveryX);
            break;
        case "y":
            let yFt = MToFt(value);
            let yDiff = Math.ceil(yFt / tickEveryY);
            returnValue = FtToM(yDiff * tickEveryY);
            break;
        case "z":
            let zFt = MToFt(value);
            let zDiff = Math.ceil(zFt / tickEveryZ);
            returnValue = FtToM(zDiff * tickEveryZ);
            break;
    }

    return returnValue;
}

function FtToM(value) {
    return value * 0.3048;
}
function MToFt(value) {
    return value * 3.28084;
}
function DegToRad(value) {
    return value * (3.141592 / 180);
}
function toFixed(num, fixed) {
    var re = new RegExp('^-?\\d+(?:\.\\d{0,' + (fixed || -1) + '})?');
    return num.toString().match(re)[0];
}
function clamp(num, min, max) {
    return Math.min(Math.max(num, min), max);
}

function drawPointText(point) {
    if (point === null) {
        label.text = "";
        return;
    }

    var dist = toFixed(MToFt(point.z)/3.0,2);
    var apex = toFixed(MToFt(point.y),1);
    var disp = toFixed(MToFt(point.x),2);

    var txt = 
        "Dispersion: " + disp + " ft\n" +
        "Apex: " + apex + " ft\n" +
        "Distance: " + dist + " yd";
    label.text = txt;
}

function getAdjustedMotionList(motions, angle) {
    
    if(!motions){
        return;
    }

    // Define a helper class to represent a vector
    class TTVector3 {
        constructor(x, y, z) {
            this.x = x;
            this.y = y;
            this.z = z;
        }

        // Subtract another vector
        subtract(vector) {
            return new TTVector3(this.x - vector.x, this.y - vector.y, this.z - vector.z);
        }

        // Static method to rotate a vector around a pivot
        static rotateAroundPivot(vector, pivot, angles) {
            // For simplicity, this example assumes 2D rotation around the Z axis only
            const cos = Math.cos(angles.z);
            const sin = Math.sin(angles.z);
            const x = cos * (vector.x - pivot.x) - sin * (vector.y - pivot.y) + pivot.x;
            const y = sin * (vector.x - pivot.x) + cos * (vector.y - pivot.y) + pivot.y;
            return new TTVector3(x, y, vector.z);
        }
    }

    const firstPos = motions[0];
    const offset = new TTVector3(firstPos[0], firstPos[1], firstPos[2]);

    const tempMotionList = motions.map(motion => {
        const pos = motion;
        return new TTVector3(pos[0], pos[1], pos[2]).subtract(offset);
    });

    if (angle !== 0) {
        const radAngle = angle * 0.0174533;
        for (let i = 0; i < tempMotionList.length; ++i) {
            tempMotionList[i] = TTVector3.rotateAroundPivot(tempMotionList[i], new TTVector3(0, 0, 0), { x: 180 * 0.0174533, y: 0, z: -radAngle });
        }
    }

    let mToYd = 1.094;
    const finalMotionList = tempMotionList.map(tempVector => {
        return [tempVector.x / mToYd, tempVector.y / mToYd,tempVector.z / mToYd];
    });
 
    return finalMotionList;
    
}

export { initializeScene, drawTraj, drawTrajCalc, getAdjustedMotionList, engine, drawScene, resetScene };
